import { Money } from "../common/money";

export interface AddNewMeterNumberRequest {
    meterNumber?: string;
    accountNumber?: string;
    consumerType?: string;
    residencyStatus?: string;
}

export interface SaveAsDraftMeterRequest {
    meterNumber?: string;
    accountNumber?: string;
    consumerType?: string;
    residencyStatus?: string;
}

export enum ExportFormat {
    Pdf = 1,
    Excel = 2,
}

// AEDC is the source of truth for an aedc customer's accounts; local meters are only a projection.
export interface AedcRelatedAccount {
    accountNumber: string;
    meterNumber: string;
    isPrepaid: boolean;
    name: string | null;
    accountType: string;
    scType: string;
    address: string | null;
    tariff: string | null;
}

export interface GeneratePrepaidStatementRequest {
    meterNumber: string;
    from: string; // date-only (yyyy-MM-dd)
    to: string; // date-only (yyyy-MM-dd)
    exportFormat: ExportFormat;
}

export interface GeneratePostpaidStatementRequest {
    accountNumber: string;
    // Required on aedc, whose statement provider takes a period; ignored elsewhere.
    from?: string; // date-only (yyyy-MM-dd)
    to?: string; // date-only (yyyy-MM-dd)
    exportFormat: ExportFormat;
}

// Query params for the statement-of-account GET endpoints (PascalCase — backend binds [AsParameters]).
export interface PrepaidStatementParams {
    MeterId: string;
    From: string; // date-only (yyyy-MM-dd)
    To: string; // date-only (yyyy-MM-dd)
}

export interface PostpaidStatementParams {
    MeterId: string;
}

export interface StatementOfAccountTransaction {
    transactionDate: string; // DateTime (ISO string)
    transactionType: string;
    description: string | null;
    referenceId: string;
    units: number | null; // decimal?
    debit: Money | null;
    credit: Money | null;
    runningBalance: Money | null;
    amount: Money | null;
}

export interface StatementOfAccountData {
    statementType: string;
    transactions: StatementOfAccountTransaction[];
}

// Prepaid transaction detail (GET account-activities/prepaid-transactions/{referenceId}). All fields nullable.
export interface PrepaidTransactionData {
    token: string | null;
    customerName: string | null;
    tariffName: string | null;
    customerAddress: string | null;
    totalKwh: number | null;
    receiptNumber: string | null;
    electricitySerialNumber: string | null;
    meterNumber: string | null;
    operatorName: string | null;
    stationCode: string | null;
    supplyGroupCode: string | null;
    tariffIndex: number | null;
    transactionAmount: number | null;
    vendType: number | null;
    createdDateTime: string | null; // DateTime?
    completedDateTime: string | null; // DateTime?
    vendorCompanyName: string | null;
}